import React from 'react';
import Box from '@amzn/awsui-components-console/box';

export const WORKFLOW_EXECUTIONS_INFO_HEADER = 'About Workflow Executions';

interface WorkflowExecutionsInfoContentProps {
	entityName: string;
	hasSubWorkflows?: boolean;
}

export const WorkflowExecutionsInfoContent: React.FC<WorkflowExecutionsInfoContentProps> = ({
	entityName,
	hasSubWorkflows = false,
}) => (
	<div style={{ width: '280px' }}>
		<Box variant="p" padding={{ bottom: 'xs' }}>
			Each item below is a workflow execution for{' '}
			<strong>{entityName}</strong>. Select one to view its status and task
			details on the right.
		</Box>
		<Box variant="h5" padding={{ top: 'xs', bottom: 'xxs' }}>
			Sorting
		</Box>
		<Box variant="p" padding={{ bottom: 'xs' }}>
			Use the Status / Recent selector to switch how executions are ordered:
		</Box>
		<ul className="workflow-executions-info-list">
			<li>
				<strong>Status</strong> — grouped into sections (In progress,
				Completed, Draft, then others) with a count per section.
			</li>
			<li>
				<strong>Recent</strong> — a flat list sorted by most recently updated
				first.
			</li>
		</ul>
		{hasSubWorkflows && (
			<>
				<Box variant="h5" padding={{ top: 'xs', bottom: 'xxs' }}>
					Sub-workflows
				</Box>
				<Box variant="p" padding={{ bottom: 'xs' }}>
					Executions started by a parent workflow are hidden by default. Turn
					on <strong>Show Sub-Workflows</strong> to include them in the list.
				</Box>
			</>
		)}
		<Box variant="small" color="text-body-secondary" padding={{ top: 's' }}>
			The number in the heading is the total count of executions for this
			entity.
		</Box>
	</div>
);
